import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "../api";
import "./Login.css";

export default function ResetPassword() {
  const [searchParams]          = useSearchParams();
  const navigate                = useNavigate();
  const token                   = searchParams.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");
  const [success, setSuccess]   = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError("");

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      setSuccess(true);
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      setError(err.response?.data?.detail || "Invalid or expired reset link. Please request a new one.");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-right" style={{ width: "100%" }}>
          <div className="login-card">
            <h2>Invalid link</h2>
            <p className="login-card-sub">This reset link is missing or malformed.</p>
            <Link to="/forgot-password" className="btn-primary login-btn" style={{ display: "block", textAlign: "center", marginTop: "24px", textDecoration: "none" }}>
              Request a new link
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-left">
        <div className="login-brand">
          <div className="login-logo-mark">⬡</div>
          <div>
            <div className="login-brand-name">CommPro</div>
            <div className="login-brand-sub">Powered by Rosegate</div>
          </div>
        </div>
        <div className="login-hero-text">
          <h1>Commission management,<br/><span>simplified.</span></h1>
          <p>Track loans, manage commissions, and handle exceptions — all in one place built for mortgage professionals.</p>
        </div>
      </div>

      <div className="login-right">
        <div className="login-card">
          {success ? (
            <>
              <h2>Password updated!</h2>
              <p className="login-card-sub">
                Your password has been reset successfully. Redirecting you to sign in…
              </p>
              <Link to="/login" className="btn-primary login-btn" style={{ display: "block", textAlign: "center", marginTop: "24px", textDecoration: "none" }}>
                Sign In Now
              </Link>
            </>
          ) : (
            <>
              <h2>Set a new password</h2>
              <p className="login-card-sub">Choose a strong password for your account.</p>

              <form onSubmit={handleSubmit} className="login-form">
                {error && <div className="login-error">{error}</div>}

                <div className="form-group">
                  <label>New Password</label>
                  <input
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="At least 8 characters"
                    required autoFocus
                  />
                </div>

                <div className="form-group">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                    placeholder="Repeat your new password"
                    required
                  />
                </div>

                <button type="submit" className="btn-primary login-btn" disabled={loading}>
                  {loading ? "Saving..." : "Update Password →"}
                </button>
              </form>

              <p style={{ textAlign: "center", marginTop: "20px", fontSize: "14px", color: "var(--text-muted)" }}>
                <Link to="/login" style={{ color: "var(--primary)" }}>Back to Sign In</Link>
              </p>
            </>
          )}
        </div>

        <p className="login-footer">
          © {new Date().getFullYear()} Rosegate Mortgage · CommPro
        </p>
      </div>
    </div>
  );
}
